import { DataAttributeDefinitions } from 'scrivito'

import { pisaQuoteDataClass } from './Pisa/pisaQuoteDataClass'

const attributes: DataAttributeDefinitions = {}

export const Quote = pisaQuoteDataClass(attributes)
